<div class="flex flex-col min-h-screen">
  <app-header *ngIf="(storageService.isLogged$ | async) && !(isPhysican)"></app-header>

  <div class="flex flex-col flex-grow">
    <router-outlet *ngIf="!(storageService.isLogged$ | async)"></router-outlet>

    <app-sidenav class="flex flex-grow" *ngIf="storageService.isLogged$ | async">
      <router-outlet></router-outlet>

      <ngx-spinner
        bdColor="rgba(255,255,255,0.7)"
        size="medium"
        color="#4663AE"
        type="square-jelly-box"
        [fullScreen]="true"
        [disableAnimation]="false"
      ></ngx-spinner>
    </app-sidenav>
  </div>

  <!-- FOOTER (GLOBAL) -->
  <app-footer *ngIf="footerEnabled$ | async"></app-footer>
</div>
